var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useState } from 'react';
import { ActionButton, OptionList, OptionListItem, OptionMenu, OptionMenuProvider, Option, Sidebar, Styler, UserIcon, Divider2, } from '@honeycomb/ui-core';
import { useAccount, useGlobalContext, useSignOut } from '@honeycomb/data';
import { AccountScreenEnum, accountScreenRouting, accountSettingsRouting, accountTripCSRsSelectedRouting, accountTripsRouting, } from '@honeycomb/routing';
import { useRouter } from 'next/router';
export function AccountMenuTrigger({ buttonColor = 'primary.base', }) {
    var _a, _b;
    const { isLoggedIn, refreshSignedIn, userData, userLoading } = useAccount();
    const router = useRouter();
    const { query } = router;
    const tripId = (_b = (_a = query === null || query === void 0 ? void 0 : query.bookedTripId) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '';
    const { resourceStrings: { LOGIN_SIGN_IN_LABEL, MYB_ACCOUNTMENU_MYTRIPS, LOGIN_SIGNED_IN_LABEL }, configSettings: { HcSignInLink }, } = useGlobalContext();
    const signInLink = HcSignInLink;
    const { signOut } = useSignOut([refreshSignedIn, () => accountScreenRouting(null)]);
    const [sideBarOpen, setSideBarOpen] = useState(false);
    const onAccountSettingRoutingSubmit = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        yield accountSettingsRouting();
        setSideBarOpen(false);
    }), []);
    const accountScreenRoutingHandle = useCallback(() => {
        (() => __awaiter(this, void 0, void 0, function* () {
            try {
                yield accountScreenRouting(signInLink !== null && signInLink !== void 0 ? signInLink : AccountScreenEnum.SIGN_IN);
            }
            catch (error) {
                console.log('error', error);
            }
        }))();
    }, [signInLink]);
    // mobile show the user icon
    // desktop show Sign in and user icon
    const loggedInText = isLoggedIn ? LOGIN_SIGNED_IN_LABEL : LOGIN_SIGN_IN_LABEL;
    const accountActionButton = useCallback((isDesktop) => {
        if (isDesktop) {
            return (React.createElement(ActionButton, { onClick: isLoggedIn ? () => setSideBarOpen(true) : accountScreenRoutingHandle, weight: "semiBold", color: buttonColor, underline: "none" }, loggedInText));
        }
        return (React.createElement(ActionButton, { onClick: isLoggedIn ? () => setSideBarOpen(true) : accountScreenRoutingHandle, color: buttonColor, icon: React.createElement(UserIcon, null), "aria-label": loggedInText }));
    }, [isLoggedIn, accountScreenRoutingHandle, buttonColor, loggedInText]);
    if (userLoading) {
        return null;
    }
    const optionProps = {
        button: true,
        defaultGutters: true,
        cornerStyle: 'square',
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(React.Fragment, null,
            React.createElement(Styler, { display: { xs: 'none', m: 'block' } }, accountActionButton(true)),
            React.createElement(Styler, { display: { m: 'none' } }, accountActionButton(false))),
        React.createElement(Sidebar, { side: "end", open: sideBarOpen, onClose: () => setSideBarOpen(false), width: "m" },
            React.createElement(OptionMenuProvider, { HeaderProps: { 'data-dd-privacy': 'mask' } },
                React.createElement(OptionMenu, { title: `Hello ${(userData === null || userData === void 0 ? void 0 : userData.firstName) || 'User'}`, open: sideBarOpen },
                    React.createElement(OptionList, null,
                        React.createElement(OptionListItem, null,
                            React.createElement(Option, Object.assign({ onClick: () => {
                                    accountTripsRouting();
                                    setSideBarOpen(false);
                                } }, optionProps), MYB_ACCOUNTMENU_MYTRIPS)),
                        tripId ? (React.createElement(OptionListItem, null,
                            React.createElement(Option, Object.assign({ onClick: () => {
                                    if (tripId) {
                                        const selectedTripId = parseInt(tripId);
                                        accountTripCSRsSelectedRouting(selectedTripId);
                                        setSideBarOpen(false);
                                    }
                                } }, optionProps), "Inbox"))) : null,
                        React.createElement(OptionListItem, null,
                            React.createElement(Option, Object.assign({ onClick: onAccountSettingRoutingSubmit }, optionProps), "Settings")),
                        React.createElement(Divider2, null),
                        React.createElement(OptionListItem, null,
                            React.createElement(Option, Object.assign({ onClick: () => {
                                    signOut();
                                    setSideBarOpen(false);
                                } }, optionProps), "Sign out"))))))));
}
